<template>
    <!--判断scopedSlots.default可知道是否存在子元素-->
    <el-table-column v-if="$scopedSlots.default" v-bind="$attrs" :key="$attrs.label" :class-name="className"
        :min-width="minWidth" :width="width">
        <!--原element组件使用了作用域插槽, 这里仿照-->
        <template slot-scope="scope">
            <slot v-bind="scope"></slot>
        </template>
        <!--使用 slot 自定义 header-->
        <template slot="header" slot-scope="scope">
            <slot name="header" v-bind="scope">
                <div style="display: flex; flex-direction: row; align-items: center">
                    <div v-if="$attrs.autoWidth == true && disableAutoWidth == false"
                        style="width: 100%; height: 100%; padding-right: 10px; white-space: nowrap" @click="toggle()">
                        <i v-if="isToggle" class="el-icon-s-fold" style="color: orange">
                            <span style="color: #606266">{{ $attrs.label }}</span>
                        </i>
                        <i v-if="!isToggle" class="el-icon-s-unfold" style="color: #606266">
                            <span style="color: #606266">{{ $attrs.label }}</span>
                        </i>
                    </div>
                    <span v-else>{{ $attrs.label }}</span>
                    <i v-if="$attrs.label == '操作' && $attrs.isCanSet" @click="showSets()" class="el-icon-s-tools"
                        style="margin-left: 5px"></i>
                </div>
            </slot>
            <!-- 把弹出层丢到这里 -->
            <el-dialog v-if="$attrs.label == '操作' && $attrs.isCanSet && tableSetsVisible" :close-on-click-modal="false"
                title="自定义列展示设置" @close="closeDialog" :visible.sync="tableSetsVisible" append-to-body width="600px"
                class="table-sets-dialog">
                <div class="dialog-content" v-if="tableSetsVisible">
                    <tableSets :tableCode="tableCode" @closeDialog="closeDialog"></tableSets>
                </div>
            </el-dialog>
        </template>
    </el-table-column>
    <!-- 普通列 -->
    <el-table-column v-else v-bind="$attrs" :key="$attrs.label" :class-name="className"></el-table-column>
</template>
<script>
import tableSets from '@/components/common/tableSets_v2.vue';
export default {
    name: 'chjtablecolumn',
    components: {
        tableSets
    },
    computed: {
        // table数据
        values(val) {
            const data = this.$parent.data || [];
            let tableData = data.map(item => item[this.$attrs.prop]);
            return tableData;
        },
        // 是否自适应列宽, 默认是
        isFit() {
            return (this.$parent.$attrs.autoFit === undefined && this.$attrs.fit === undefined) || (this.$parent.$attrs.autoFit === false && this.$attrs.fit !== undefined);
        },
        // 为存在scope的添加className
        className() {
            const parentClass = this.$attrs['class-name'] || '';
            const classPre = this.$attrs.prop || `encode-${this.transChar(this.$attrs.label)}`; // 有的列因为有slotScope而不给prop
            return classPre ? `${parentClass} ${classPre}-column` : '';
        },
        width: {
            get(val) {
                if (!this.$attrs.label) return undefined;
                if (!this.isFit) return undefined;
                let width = 0;
                if (this.$attrs.autoWidth == true) {
                    if (this.getComputedWidth > 0) {
                        width = this.getComputedWidth + 10;
                    } else {
                        let maxOne = 0;
                        //宽度的最小值取label标题宽度
                        if (this.$attrs.label == '操作') {
                            maxOne = this.$attrs.label.length * this.defaultFontRate.CHAR_RATE * this.defaultFontSize;
                        } else {
                            maxOne = this.$attrs.label.length * this.defaultFontRate.CHAR_RATE * this.defaultFontSize + 10;
                        }
                        maxOne < 40 && (maxOne = 60);
                        width = maxOne;
                    }
                } else if (this.$attrs.width) {
                    width = this.$attrs.width;
                } else {
                    width = undefined;
                }
                return width;
            }
        },
        // 列最小宽度
        minWidth: {
            get(val) {
                if (!this.$attrs.label) return undefined;
                if (!this.isFit) return undefined;
                let width = 0;
                if (this.$attrs.autoWidth == true) {
                    width = this.getComputedWidth + 10;
                } else if (this.$attrs.minWidth) {
                    width = this.$attrs.minWidth;
                } else {
                    let maxOne = 0;
                    //宽度的最小值取label标题宽度
                    if (this.$attrs.label == '操作') {
                        maxOne = this.$attrs.label.length * this.defaultFontRate.CHAR_RATE * this.defaultFontSize;
                    } else {
                        maxOne = this.$attrs.label.length * this.defaultFontRate.CHAR_RATE * this.defaultFontSize + 10;
                    }
                    width = maxOne;
                }
                return width;
            }
        },
        // 字体大小
        fontSize() {
            return this.$attrs.fontSize || (this.$ELEMENT || {}).fontSize || this.defaultFontSize;
        },
        // 字体比例
        fontRate() {
            return {
                ...this.defaultFontRate, // 默认值
                ...((this.$ELEMENT || {}).defaultFontRate || {}), // 根注册参数 (Vue.use 时的第二个参数)
                ...(this.$attrs.defaultFontRate || {}) // 父组件属性
            };
        }
    },
    watch: {
        values: {
            // immediate: true,
            handler(val) {
                if (this.$attrs.autoWidth == true) {
                    this.isFit !== false &&
                        this.$nextTick(() => {
                            // 详情中的列表需要在nextTick才能生效
                            if (this.$scopedSlots.default) {
                                // 存在自定义节点
                                setTimeout(() => {
                                    try {
                                        //这里加trycatch的原因：弹窗页码也存在table控件，关闭弹窗后会原因找不到对于的元素而触发脚本错误
                                        // 首次获取不到子节点, setTimeout才行
                                        // 可能存在贴边列, 需要使用包含 fixed 的类名
                                        let fixed = this.$attrs.fixed;
                                        const bodyWrapper = fixed
                                            ? document.querySelector(`.el-table__fixed${fixed === 'right' ? `-${fixed}` : ''}`).querySelector('.el-table__fixed-body-wrapper')
                                            : document.querySelector('.el-table__body-wrapper');
                                        const nodes = bodyWrapper.querySelectorAll(`.${this.$attrs.prop || `encode-${this.transChar(this.$attrs.label)}`}-column`);
                                        if (nodes.length) {
                                            //取同一列的每一行出来,找出最大值(内容长度)和最小值
                                            let maxList = [];
                                            let minList = [];
                                            let getComputedWidths = [];
                                            Array.from(nodes).map(item => {
                                                maxList.push(item.innerText.length);
                                                getComputedWidths.push(item.innerText.length * this.defaultFontRate.CHAR_RATE * this.defaultFontSize);
                                            });

                                            let maxlength = Math.max(...maxList);
                                            let maxWidth = Math.max(...getComputedWidths);
                                            if (this.lastLength != maxlength) {
                                                this.lastLength = maxlength;
                                            }
                                            if (maxlength >= 6) {
                                                this.disableAutoWidth = false;
                                            } else {
                                                maxWidth = maxWidth + 10;
                                            }

                                            if (maxWidth < 60) {
                                                maxWidth = 60;
                                            }

                                            this.lastWidth = maxWidth;

                                            this.getComputedWidth = maxWidth;
                                            this.isToggle = false;
                                        }
                                    } catch (error) {
                                        // 
                                    }
                                }, 0);
                            }
                        });
                }
            }
        }
    },
    data() {
        return {
            disableAutoWidth: true,
            lastWidth: 0,
            lastLength: 0,
            isToggle: false,
            mWidth: 0,
            getComputedWidth: 0, // 自定义列中获取元素计算的宽度
            defaultFontSize: 12,
            // 计算字体比率
            defaultFontRate: {
                CHAR_RATE: 1.1, // 汉字比率
                NUM_RATE: 0.65, // 数字
                OTHER_RATE: 0.5 // 除汉字和数字以外的字符的比率
            },
            tableSetsVisible: false,
            tableCode: ''
        };
    },
    created() { },
    mounted() { },
    methods: {
        // 获取数组中元素按字体比例最长长度
        getMaxLength(arr) {
            return arr.reduce((length, item) => {
                if (item) {
                    const str = item.toString();
                    const char = str.match(/[\u2E80-\u9FFF]/g);
                    const charLength = char ? char.length : 0;
                    const num = str.match(/\d|\./g);
                    const numLength = num ? num.length : 0;
                    const otherLength = str.length - charLength - numLength;
                    let newLength = charLength * this.defaultFontRate.CHAR_RATE + numLength * this.defaultFontRate.NUM_RATE + otherLength * this.defaultFontRate.OTHER_RATE;
                    if (str.includes('\n')) newLength = this.getMaxLength(str.split('\n'));
                    if (length < newLength) {
                        length = newLength;
                    }
                }
                return length;
            }, 0);
        },
        // 转换汉字为class支持的字母
        transChar(char) {
            return encodeURIComponent(char).replace(/[^a-zA-z]/g, 'eUC');
        },
        toggle() {
            if (!this.mWidth) {
                this.mWidth = this.getButtonWidth();
            }
            this.isToggle = !this.isToggle;
            if (this.isToggle) {
                this.$nextTick(() => {
                    this.regainVisibility(false);
                    setTimeout(() => {
                        this.getComputedWidth = this.mWidth;
                    }, 100);
                });
            } else {
                this.$nextTick(() => {
                    this.getComputedWidth = this.lastWidth;
                    setTimeout(() => {
                        this.regainVisibility(true);
                    }, 100);
                });
            }
        },
        /**
         * 获取此页面第一个表格操作列前两个按钮的宽度和内外边距的总和，作为缩放时的最小宽度
         * 宽度和加的20px是指的多余的边距，须注意在本页104行位置还加入了10px
         * 按钮数量小于2时不处理
         * @returns 最小宽度和 || 未获取节点时返回默认宽度：80
         */
        getButtonWidth() {
            let btnNodeArr = document.querySelectorAll('.el-table__fixed-right .el-table__row > td:last-child .ops-ctn');
            if (!btnNodeArr) return 60;
            let widthArr = [];
            btnNodeArr.forEach(rowEle => {
                let minWidth = 60;
                let btnSelector = rowEle.querySelectorAll('.el-button');
                if (!btnSelector || btnSelector.length < 2) {
                    widthArr.push(60);
                    return;
                }
                minWidth = btnSelector[0].offsetWidth + btnSelector[1].offsetWidth + 10;
                widthArr.push(minWidth);
            });
            return Math.max(...widthArr);
        },
        // 是否隐藏/展示表格中操作栏2个以上的按钮
        regainVisibility(isShow) {
            let btnNodeArr = document.querySelectorAll('.el-table__fixed-right .el-table__row > td:last-child .ops-ctn');
            if (!btnNodeArr) return;
            btnNodeArr.forEach(rowEle => {
                let btnSelector = rowEle.querySelectorAll('.el-button');
                if (!btnSelector || btnSelector.length < 2) return;
                btnSelector.forEach((btnEle, btnIdx) => {
                    if (btnIdx > 1) {
                        btnEle.style.visibility = isShow ? 'visible' : 'hidden';
                    }
                });
            });
        },
        showSets() {
            this.$util.getSysConfig('ygsfkzdylb').then(data => {
                if (data && data.Result) {
                    this.tableCode = this.$parent.$attrs.tableCode;
                    if (this.tableCode) {
                        this.tableSetsVisible = true;
                    }
                }
                else this.$util.warningMsg("您的企业已经关闭员工自定义列表展示功能");
            });
        },
        closeDialog(isEdit) {
            this.tableCode = '';
            this.tableSetsVisible = false;
            if (isEdit) {
                this.$util.refresh();
            }
        }
    }
};
</script>

<style lang="less">
.table-sets-dialog-none {
    display: none;
}
</style>
